(function () {
  var CLIENT_ID = 'EklzfUgp_P';
  var SHOP = 'orangusport.myshopify.com';

  function getHash() {
    return typeof loox_global_hash !== 'undefined' ? loox_global_hash : '';
  }

  function renderStars(el, rating, raters) {
    var filled = Math.round(rating);
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += i <= filled
        ? '<svg class="gs-lx-s gs-lx-s-on" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'
        : '<svg class="gs-lx-s" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    el.innerHTML =
      '<span class="gs-lx-stars">' + stars + '</span>' +
      '<span class="gs-lx-count">(' + raters + ')</span>';
    el.classList.add('gs-lx-ready');
  }

  function init() {
    var els = document.querySelectorAll('.loox-rating[data-id]:not([data-gs-lx-done])');
    if (!els.length) return;

    var ids = [];
    var map = {};
    els.forEach(function (el) {
      var id = el.getAttribute('data-id');
      if (!id) return;
      el.setAttribute('data-gs-lx-done', '1');
      if (!map[id]) { ids.push(id); map[id] = []; }
      map[id].push(el);
    });

    if (!ids.length) return;

    var hash = getHash();
    var url = 'https://loox.io/widget/' + CLIENT_ID + '/ratings?products_ids=' + ids.join(',') +
      (hash ? '&h=' + hash : '') + '&shop=' + SHOP;

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) return;
        (data.ratings || []).forEach(function (item) {
          if (!item.rating || !item.raters) return;
          (map[String(item.pid)] || []).forEach(function (el) {
            renderStars(el, item.rating, item.raters);
          });
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mo = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.loox-rating[data-id]:not([data-gs-lx-done])')) found = true;
        if (!found && node.querySelector && node.querySelector('.loox-rating[data-id]:not([data-gs-lx-done])')) found = true;
      });
    });
    if (found) init();
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
